import { Button, Dropdown, Menu } from 'antd';
import { FaDownload, FaFileExcel, FaFilePdf } from 'react-icons/fa';
import { ExportFormat } from './exportFiles';

type ExportFormatButtonProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  onExport: (format: ExportFormat) => void;
};

export const ExportFormatButton = ({
  className,
  disabled,
  label = 'Exporter',
  onExport,
}: ExportFormatButtonProps) => {
  const menu = (
    <Menu
      onClick={({ key }) => {
        onExport(key as ExportFormat);
      }}
    >
      <Menu.Item key='excel' icon={<FaFileExcel />}>
        Exporter Excel
      </Menu.Item>
      <Menu.Item key='pdf' icon={<FaFilePdf />}>
        Exporter PDF
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} disabled={disabled}>
      <Button className={className} icon={<FaDownload />} disabled={disabled}>
        {label}
      </Button>
    </Dropdown>
  );
};
